import { render, staticRenderFns } from "./LocalUnitEditActivity.vue?vue&type=template&id=4cb3470c"
import script from "./LocalUnitEditActivity.vue?vue&type=script&lang=ts"
export * from "./LocalUnitEditActivity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports